import { render } from "./BpmnEventLabel.vue?vue&type=template&id=795d802a&scoped=true"
import script from "./BpmnEventLabel.vue?vue&type=script&lang=js"
export * from "./BpmnEventLabel.vue?vue&type=script&lang=js"

import "./BpmnEventLabel.vue?vue&type=style&index=0&id=795d802a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795d802a"]])

export default __exports__